export default {
  consumptionBatches: (state) => state.consumptionBatches,
  ticketsForConsumption: (state) => state.ticketsForConsumption
}
